<template>
  <div class="message">
    <scroll ref="scroll" class="messageListWrapper"
      v-if="messageData"
      :data="messageData"
      :pullUpLoad="pullUpLoadObj"
      :pullDownRefresh="pullDownRefreshObj"
      @pullingUp="onPullingUp"
      @pullingDown="onPullingDown">
      <div class="messageList">
        <div class="title">
          <div class="title-avatar" v-if="baseData">
            <img :src="baseData.avatar_url" alt="">
          </div>
          <div class="title-note">我的留言</div>
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in messageData" :key="index">
            <div class="item-message">{{item.content}}</div>
            <div class="item-else">
              <span>{{item.created_at}}</span>
              <div class="evaluate wishwall-like" v-if="baseData.enable_favor === 1" :class="{active: item.is_favor}" @click="evaluate(item.wish_id, index, item.is_favor, item.favor_count)">
                <i class="iconfont icon-dianzan"></i>
                <span>{{item.favor_count}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroll>
    <div class="messageNo" v-else>
      <img :src="imgArr[0]" alt="">
      <span>你还没有留言</span>
    </div>
    <div class="go-back" @click="$router.go(-1)">返回</div>
    <!-- 强制关注页面 -->
    <Focus v-if="baseData && needFocus"
      :needFocus.sync="needFocus"
      :qrcodeURL="baseData.app_qr_code"
      :keyWord="baseData.key_word" />
  </div>
</template>

<script>
import { getDate } from '../assets/js/tool'
import { getSelfwish, getChangeisfavor } from 'api'

import Scroll from '@/base/scroll/scroll.vue'
import Focus from '@/components/Focus.vue'

export default {
  name: 'message',
  data() {
    return {
      currentPage: 1, // 我的愿望请求page number
      zanIndex: [], // 点赞index集合
      msgData: [],
      imgArr: [
        require('../assets/img/no-message.png')
      ],
      messageData: null,
      n: 0,
      n1: 10000,
      pullUpLoad: true,
      pullDownRefresh: true,
      pullDownRefreshThreshold: 90,
      pullDownRefreshStop: 40,
      needFocus: false, // 是否强制关注
    }
  },
  watch: {
    pullUpLoadObj: {
      handler(val) {
        const scroll = this.$refs.scroll.scroll
        if (val) {
          scroll.openPullUp()
        } else {
          scroll.closePullUp()
        }
      },
      deep: true
    },
    pullDownRefreshObj: {
      handler(val) {
        const scroll = this.$refs.scroll.scroll
        if (val) {
          scroll.openPullDown()
        } else {
          scroll.closePullDown()
        }
      },
      deep: true
    },
  },
  computed: {
    query() {
      return this.$route.query
    },
    params() {
      return Object.assign({}, this.query)
    },
    baseData() {
      return JSON.parse(sessionStorage.getItem('baseData'))
    },
    pullUpLoadObj: function () {
      return this.pullUpLoad ? {
        threshold: 0,
        text: {more: '查看更多', noMore: '- 没有更多了 -'}
      } : false
    },
    pullDownRefreshObj: function () {
      return this.pullDownRefresh ? {
        threshold: parseInt(this.pullDownRefreshThreshold),
        stop: parseInt(this.pullDownRefreshStop),
        text: '刷新成功'
      } : false
    },
  },
  created() {
    this.getSelfWish()
  },
  methods: {
    getSelfWish(reset) {
      if (this.pullUpFlag) return
      this.pullUpFlag = true
      if (reset) {
        this.messageData = null
        this.currentPage = 1
      }
      this.params.page = this.currentPage
      getSelfwish(this.params).then(res => {
        if (res.code === 3001) {
          const data = res.data
          // 有数据时
          if (data.list.length) {
            // 如果数据非空，则concat新数据
            this.messageData = this.messageData ? this.messageData.concat(data.list) : data.list
            // page number递增
            this.currentPage += 1
          } else {
            // 为空没有新数据，手动forceUpdate
            this.$refs.scroll.forceUpdate()
          }
        }
        this.pullUpFlag = false
      })
    },
    onPullingDown() {
      // 模拟更新数据
      setTimeout(() => {
        if (this._isDestroyed) {
          return
        }
        this.getSelfWish(1)
      }, 2000)
    },
    onPullingUp() {
      // 更新数据
      setTimeout(() => {
        if (this._isDestroyed) {
          return
        }
        this.getSelfWish()
      }, 1500)
    },
    evaluate(id, index, favor, count) {
      if (this.flag) return
      this.flag = true
      this.params.wish_id = id
      getChangeisfavor(this.params).then(res => {
        if (res.code === 3001) {
          count = favor ? count - 1 : count + 1
          this.$set(this.messageData[index], 'is_favor', !favor)
          this.$set(this.messageData[index], 'favor_count', count)
        } else if (res.code === 5011) {
          this.needFocus = true
        } else {
          alert(res.msg)
        }
        this.flag = false
      })
    },
  },
  components: {
    Scroll,
    Focus
  }
}
</script>

<style lang="stylus" scoped>
.message
  height: 100vh
  background-color: #f6f6f6
  overflow: hidden
  >>>.pullup-wrapper
    padding-bottom: 0.8rem!important;
  .messageListWrapper
    height: 100vh
    .messageList
      font-size: 0.14rem
      .title
        margin-bottom: 0.2rem
        text-align: center
        font-weight: 500
        color: #4a4a4a
        overflow: hidden
        .title-avatar
          margin: 0.1rem auto 0.07rem
          width: 0.5rem
          height: 0.5rem
          background-color: orange
          border-radius: 50%
          overflow: hidden
          img
            width: 100%
            height: 100%
      .list
        color: #9b9b9b
        .item
          margin:0 0.08rem 0.1rem
          padding: 0.06rem 0.12rem 0.06rem 0.2rem
          min-height: 0.68rem
          background-color: #fff
          .item-message
            margin-bottom: 0.1rem
            min-height: 0.42rem
            line-height: 1.5
            white-space: pre-wrap;
          .item-else
            display: flex
            justify-content: space-between
            .evaluate
              &.active
                color: #ec4d5e
                color: var(--color)
              span
                margin-left: 0.06rem
  .messageNo
    text-align: center
    font-size: 0.18rem
    color: #9b9b9b
    img
      margin: 2.17rem auto 0.32rem
      width: 1.5rem
      height: 0.63rem
  .go-back
    position: fixed;
    width: 1.83rem;
    height: 0.35rem;
    line-height: 0.35rem;
    left: 50%;
    margin-left: -0.91rem;
    background: #eb4c5e;
    bottom: 0.34rem;
    text-align: center;
    border-radius: 0.35rem;
    color: #fff;
    box-shadow: 0px 2px 2px 0px rgba(4,0,0,0.56)
</style>

